/**
 * ENG-4174 / ENG-4247: derive the LiveKit participant identity for the startup
 * diagnostic probe.
 *
 * The probe (ENG-3868 LiveKitStartupProbeScheduler → ConnectionCheck) runs a REAL
 * SFU join to measure websocket/webrtc/turn connectivity. It MUST join with an
 * identity DISTINCT from the live room participant (the app id): the SFU's
 * duplicate-identity policy evicts the existing participant when a second
 * connection joins with the same identity (DisconnectReason.DUPLICATE_IDENTITY),
 * which is terminal (engine close, no reconnect) and permanently kills the live
 * cloud transport — the regression that wedged web Studio boot until a refresh.
 *
 * Pure + exported so the distinctness invariant is unit-tested independently.
 * Per rule: think-in-systems (ai.knowledge/global).
 */
export const DIAGNOSTIC_IDENTITY_SUFFIX = '-lkdiag';

/** @returns a diagnostic identity guaranteed distinct from `appId`. */
export const diagnosticIdentity = (appId: string): string =>
  `${appId}${DIAGNOSTIC_IDENTITY_SUFFIX}`;
